import { FC } from 'react';
import { GridContextProvider, GridDropZone, GridItem, swap } from 'react-grid-dnd';
import styles from './dndGrid.module.scss';
import { DndGridProps } from './dndGridTypes';

const dndGrid: FC<DndGridProps> = (props: DndGridProps) => {
    const { items, reorderItems, itemsPerRow = 4, rowHeight = 70, maxRows = 4, itemWidth = 70 } = props;

    const onChange = (_sourceId: string, sourceIndex: number, targetIndex: number) => {
        const result = swap(items, sourceIndex, targetIndex);
        reorderItems(result);
    };

    const dropZoneHeight = Math.min(Math.ceil(items.length / itemsPerRow), maxRows) * rowHeight;

    return (
        <GridContextProvider onChange={onChange}>
            <div className={styles.container} style={{ width: itemWidth * itemsPerRow }}>
                <GridDropZone
                    className={styles.dropzone}
                    id="dropzone"
                    boxesPerRow={itemsPerRow}
                    rowHeight={rowHeight}
                    style={{ height: dropZoneHeight }}
                >
                    {items.map(item => (
                        <GridItem key={item.id} className={styles['grid-item-wrapper']}>
                            {item.content}
                        </GridItem>
                    ))}
                </GridDropZone>
            </div>
        </GridContextProvider>
    );
};

export default dndGrid;
